import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTableRow
} from '@components/Styles/TableStyle';
import { CustomTextField } from '@components/Styles/CommonStyle';
import React from 'react';

const CompanyAccountCreateTableRepresent = React.memo(({ param, setParam }) => {

  return (
    <React.Fragment>
        <CustomTableRow>
            <CustomHeaderCell>대표자</CustomHeaderCell>
            <CustomBodyCell>
                <CustomTextField
                value={param.representative}
                onChange={(e) => setParam({ ...param, representative: e.target.value })}
                />
            </CustomBodyCell>
            <CustomHeaderCell>회사전화</CustomHeaderCell>
            <CustomBodyCell>
                <CustomTextField
                value={param.phone}
                onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                    setParam({ ...param, phone: value });
                    }
                }}
                />
            </CustomBodyCell>
        </CustomTableRow>
    </React.Fragment>
  );
});

export default CompanyAccountCreateTableRepresent;

